import { connect } from 'react-redux';

import { createParkingWhitelistGroup } from '../actions';
import NewWhitelistGroup from './component';

const mapDispatchToProps = { createParkingWhitelistGroup };

export default connect(null, mapDispatchToProps)(NewWhitelistGroup);
